module.exports = __webpack_public_path__ + "static/banner-a7827171d410144bbae1e9103260d167.jpg";